import { render, staticRenderFns } from "./OpenVipModal.vue?vue&type=template&id=525b4952&scoped=true&"
import script from "./OpenVipModal.vue?vue&type=script&lang=js&"
export * from "./OpenVipModal.vue?vue&type=script&lang=js&"
import style0 from "./OpenVipModal.vue?vue&type=style&index=0&id=525b4952&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b4952",
  null
  
)

export default component.exports